export default __webpack_public_path__ + "static/media/buildrun_logo2.18c4c291.png";